"use strict";import{tag as s}from"../custom-tag.js";export function settingsIcon({height:a=16,width:t=16,hidden:l=!1,title:e="Settings"}={}){return s`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${t}
      height=${a}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${l?"true":"false"}"
      role="img"
      aria-label="${e}"
    >
      <mask
        id="settings_svg__mask0_6875_6538"
        width="20"
        height="20"
        x="2"
        y="2"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="M12.001 21.998h-.122a2.84 2.84 0 0 1-2.61-2.677 5 5 0 0 1-.523-.222 2.72 2.72 0 0 1-3.91-.122 2.844 2.844 0 0 1 0-3.744c-.077-.166-.155-.333-.222-.51a2.74 2.74 0 0 1-1.91-.845 2.8 2.8 0 0 1-.7-2 2.844 2.844 0 0 1 2.655-2.61c.066-.166.133-.344.222-.522a2.72 2.72 0 0 1 .122-3.91 2.844 2.844 0 0 1 3.743 0l.522-.222a2.66 2.66 0 0 1 .845-1.866 2.72 2.72 0 0 1 2.01-.745 2.844 2.844 0 0 1 2.61 2.678q.268.096.523.222a2.67 2.67 0 0 1 1.955-.767 2.73 2.73 0 0 1 1.955.889 2.844 2.844 0 0 1 0 3.743c.078.167.155.345.222.522a2.844 2.844 0 0 1 2.61 2.589 2.8 2.8 0 0 1-.766 2.021c-.5.523-1.187.826-1.91.845a7 7 0 0 1-.223.51 2.72 2.72 0 0 1-.122 3.91 2.844 2.844 0 0 1-3.744 0l-.522.223a2.755 2.755 0 0 1-2.71 2.61M8.669 17.9a.7.7 0 0 1 .255 0q.534.281 1.11.456a.6.6 0 0 1 .4.555v.167a1.73 1.73 0 0 0 1.49 1.81 1.656 1.656 0 0 0 1.71-1.633v-.333a.555.555 0 0 1 .389-.533 6.7 6.7 0 0 0 1.11-.444.59.59 0 0 1 .667.1l.133.133a1.72 1.72 0 0 0 2.344.155 1.64 1.64 0 0 0 .42-1.81 1.6 1.6 0 0 0-.364-.544l-.245-.245a.555.555 0 0 1-.1-.644q.284-.532.456-1.111a.555.555 0 0 1 .533-.389h.333a1.58 1.58 0 0 0 1.144-.477 1.64 1.64 0 0 0 .434-1.189 1.733 1.733 0 0 0-1.778-1.555h-.177a.59.59 0 0 1-.534-.367 7 7 0 0 0-.455-1.11.61.61 0 0 1 .122-.7l.111-.111a1.71 1.71 0 0 0 .156-2.344 1.64 1.64 0 0 0-1.167-.533 1.6 1.6 0 0 0-1.188.477l-.245.245a.555.555 0 0 1-.644.1 6.4 6.4 0 0 0-1.11-.456.6.6 0 0 1-.4-.555V4.87a1.733 1.733 0 0 0-1.5-1.755 1.655 1.655 0 0 0-1.71 1.61v.334a.555.555 0 0 1-.39.533 6.7 6.7 0 0 0-1.11.445.59.59 0 0 1-.667-.1l-.133-.134a1.71 1.71 0 0 0-2.344-.155 1.64 1.64 0 0 0-.533 1.11 1.58 1.58 0 0 0 .51 1.245l.245.244a.555.555 0 0 1 .1.644 6.4 6.4 0 0 0-.455 1.111.6.6 0 0 1-.545.4H4.87a1.733 1.733 0 0 0-1.755 1.522 1.65 1.65 0 0 0 .433 1.189 1.58 1.58 0 0 0 1.177.51h.333a.555.555 0 0 1 .534.39q.165.577.444 1.11a.61.61 0 0 1-.1.678l-.133.133a1.71 1.71 0 0 0-.156 2.344 1.62 1.62 0 0 0 2.355.055l.244-.244a.58.58 0 0 1 .423-.189"
        />
        <path
          fill="currentColor"
          d="M12.001 15.333a3.332 3.332 0 1 1 0-6.664 3.332 3.332 0 0 1 0 6.664m0-5.554a2.222 2.222 0 1 0 0 4.443 2.222 2.222 0 0 0 0-4.443"
        />
      </mask>
      <g mask="url(#settings_svg__mask0_6875_6538)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=settings.js.map
